module.exports = __webpack_public_path__ + "img/wind.1cfc6e40.svg";